import $ from 'jquery';
import anime from 'animejs';

import Page from '~/page/page';
import Header from '~/header/header';

export default class Links extends Page {
  init() {
    this.state = {};
    this.param = {};
    this.elements({
      link: '.js-links-link',
      select: '.js-links-select'
    });
  }
  events() {
    this.$.link.on('click', e => this.handler(e));
    this.$.select.on('change', () => {
      const $option = this.$.select.find(':selected');
      const url = $option.val();

      location = url;
    });
  }
  handler(e) {
    e.preventDefault();

    const $current = $(e.target);

    const href = $current.attr('href');
    const $target = $(href);

    const position = $target.offset().top || null;

    this.scrollTo(position);
  }
  scrollTo(position, done) {
    if (null === position) return;

    anime({
      targets: $('html, body').get(),
      scrollTop: position - Header.getHeight() - 40,
      duration: 1000,
      easing: 'easeInOutCubic',
      complete: () => {
        if (done) done();
      }
    });
  }
}

Page.mount(Links, '.js-links');
